import { connect } from 'react-redux'
import StickerGroup from './StickerGroup.component'

function mapStateToProps (state) {
  return ({})
}

function mapDispatchToProps (dispatch) {
  return ({})
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StickerGroup)
